import React from "react";
import { useTranslation } from "react-i18next";

function DatabaseDocs() {
    const { t } = useTranslation();

    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-semibold mb-2">
                    {t("databaseDocs.title")}
                </h1>
                <p className="text-gray-600 ">
                    {t("databaseDocs.subtitle")}
                </p>
                <div className="mt-6">
                    <p className="text-gray-600 ">
                        {t("databaseDocs.intro")}
                    </p>
                </div>
            </div>

            <div className="space-y-8">
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("databaseDocs.howItWorks.title")}
                    </h2>
                    <div className="relative pb-8">
                        <div className="absolute left-4 top-2 bottom-0 w-0.5 bg-gray-200 "></div>
                        {[1, 2, 3, 4, 5].map((step) => (
                            <div
                                className={`relative flex items-start mb-8${
                                    step === 5 ? " mb-0" : ""
                                }`}
                                key={step}
                            >
                                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-500 text-white font-bold text-sm absolute">
                                    {step}
                                </div>
                                <div className="ml-12">
                                    <h3 className="text-xl font-medium mb-3">
                                        {t(
                                            `databaseDocs.howItWorks.step${step}.title`
                                        )}
                                    </h3>
                                    <div className="bg-white  shadow-sm rounded-lg border p-4">
                                        <p>
                                            {t(
                                                `databaseDocs.howItWorks.step${step}.description`
                                            )}
                                        </p>
                                    </div>
                                    {step === 3 || step === 4 || step === 5 ? (
                                        <div className=" shadow-sm rounded-lg border p-4 mt-4">
                                            <img
                                                src={`./database${step}.png`}
                                                alt="Database"
                                                className="w-full h-auto max-h-96 object-contain"
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="bg-blue-50  p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("databaseDocs.tipsForSuccess.title")}
                    </h2>
                    <ul className="space-y-4">
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t("databaseDocs.tipsForSuccess.tip1")}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t("databaseDocs.tipsForSuccess.tip2")}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t("databaseDocs.tipsForSuccess.tip3")}
                                </strong>
                            </span>
                        </li>
                        <li className="flex">
                            <span className="text-green-600 mr-2">✓</span>
                            <span>
                                <strong>
                                    {t("databaseDocs.tipsForSuccess.tip4")}
                                </strong>
                            </span>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default DatabaseDocs;
